import React, { useState, useEffect } from 'react';
import ekybService from '../../services/ekybService';
import '../../styles/ekyb.css';

const StepMiCA = ({ entityData, jurisdiction, onCheckComplete }) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [micaResult, setMicaResult] = useState(null);

  useEffect(() => {
    performMiCACheck();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const performMiCACheck = async () => {
    setLoading(true);
    setError('');

    try {
      const result = await ekybService.checkMiCARegister(entityData.name, jurisdiction);
      setMicaResult(result);
    } catch (err) {
      setError(err.message || 'MiCA register check failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleContinue = () => {
    onCheckComplete(micaResult);
  };

  if (loading) {
    return (
      <div className="ekyb-step-container">
        <div className="ekyb-loading">
          <div className="ekyb-spinner"></div>
          <span style={{ marginLeft: '12px' }}>Checking MiCA CASP register...</span>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="ekyb-step-container">
        <div className="ekyb-alert error">
          {error}
        </div>
        <div className="ekyb-button-group">
          <button
            className="ekyb-button ekyb-button-primary"
            onClick={performMiCACheck}
          >
            Retry Check
          </button>
        </div>
      </div>
    );
  }

  if (!micaResult) {
    return null;
  }

  return (
    <div className="ekyb-step-container">
      <div className="ekyb-step-header">
        <h2 className="ekyb-step-title">MiCA Register Verification</h2>
        <p className="ekyb-step-subtitle">
          Checking entity registration status in the Markets in Crypto-Assets (MiCA) CASP register.
        </p>
      </div>

      <div style={{ textAlign: 'center', marginBottom: '24px' }}>
        <span className={`ekyb-status-badge ${micaResult.registered ? 'active' : 'inactive'}`}>
          {micaResult.registered ? 'REGISTERED' : 'NOT REGISTERED'}
        </span>
      </div>

      {micaResult.registered ? (
        <div>
          <div className="ekyb-alert success">
            Entity is registered as a Crypto-Asset Service Provider (CASP) under MiCA.
          </div>

          <table className="ekyb-data-table">
            <tbody>
              <tr>
                <td>Entity Name</td>
                <td>{micaResult.entityName || entityData.name}</td>
              </tr>
              {micaResult.caspId && (
                <tr>
                  <td>CASP ID</td>
                  <td style={{ fontFamily: 'IBM Plex Mono, monospace' }}>{micaResult.caspId}</td>
                </tr>
              )}
              {micaResult.authorizationDate && (
                <tr>
                  <td>Authorization Date</td>
                  <td>{new Date(micaResult.authorizationDate).toLocaleDateString('en-GB')}</td>
                </tr>
              )}
              {micaResult.competentAuthority && (
                <tr>
                  <td>Competent Authority</td>
                  <td>{micaResult.competentAuthority}</td>
                </tr>
              )}
              {micaResult.services && micaResult.services.length > 0 && (
                <tr>
                  <td>Authorized Services</td>
                  <td>
                    <ul style={{ margin: 0, paddingLeft: '20px' }}>
                      {micaResult.services.map((service, i) => (
                        <li key={i}>{service}</li>
                      ))}
                    </ul>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="ekyb-alert info">
          {micaResult.message || 'Entity not found in MiCA CASP register. This does not indicate non-compliance if crypto-asset services are not provided.'}
        </div>
      )}

      <div className="ekyb-button-group">
        <button
          className="ekyb-button ekyb-button-primary"
          onClick={handleContinue}
        >
          Continue to Verification Report
        </button>
      </div>
    </div>
  );
};

export default StepMiCA;
